import { defineStore } from "pinia";
import api from "~/config/extensionsApi";
import { getApiAxios } from '~/helpers/index';
interface State {
  loading: boolean;
  error: any | null;
}

export const useInvoicesStore = defineStore("invoices", {
  state: (): State => ({
    loading: false,
    error: null,
  }),

  actions: {
    async fetchInvoicesDataStore(tax: string) {
      try {
        this.loading = true;
        const response = await getApiAxios(api.customer.customer_tax_info + `?tax=${tax}`);
        return response;
      } catch (error) {
        console.error("Error fetching codeVoucher:", error);
      } finally {
        this.loading = false;
      }
    },
  },
});